import { Typography } from "@mui/material";
import React from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import "../assets/css/Navbar.css";
import logo from "../assets/images/logo.png";
import useWindowDimensions from "../helpers/windowDimensions";

function NavbarC() {
  const { height, width } = useWindowDimensions();
  console.log(document.getElementsByClassName("header"));
  window.onscroll = function () {
    scrollFunction();
  };
  function scrollFunction() {
    if (
      document.body.scrollTop > 50 ||
      document.documentElement.scrollTop > 50
    ) {
      document.getElementsByClassName("header")[0].classList.add("sticky");
      // document.getElementsByClassName("header")[0].style.height="0";
      // document.getElementsByClassName("navbar-collapse")[0].classList.remove("show");
    } else {
      document.getElementsByClassName("header")[0].classList.remove("sticky");
      // document.getElementsByClassName("header")[0].style.height="auto";
      // document.getElementsByClassName("navbar-collapse")[0].classList.remove("show");
    }
  }
  const fs = {
    xs: "14px",
    sm: "14px",
    md: "12px",
    lg: "15px",
    xl: "16px",
  };
  return (
    <div data-aos="fade-up" data-aos-duration="3000" className="header">
      <Navbar
        style={{
          backgroundColor: "#03121e",
          height: width > 760 ? "75px" : "0px",
        }}
        collapseOnSelect
        className="navbar-dark"
        expand="md"
      >
        <Container>
          <Navbar.Brand href="#home">
            <img
              id="logo"
              src={logo}
              style={{ width: 50, height: 50 }}
              className="d-inline-block align-top nav-logo"
              alt="logo"
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="nav-menu">
              <Nav.Link
                id="item0"
                href="#about"
                className="nav-link"
                style={{ fontSize: "1vw" }}
              >
                <Typography
                  fontFamily={"ST MicroSquare Ex"}
                  style={{ fontWeight: 700 }}
                  sx={{
                    fontSize: fs,
                  }}
                >
                  About
                </Typography>
              </Nav.Link>
              <Nav.Link
                style={{ fontSize: "1vw" }}
                id="item1"
                href="#tvc"
                className="nav-link w"
              >
                <Typography
                  fontFamily={"ST MicroSquare Ex"}
                  style={{ fontWeight: 700 }}
                  sx={{
                    fontSize: fs,
                  }}
                >
                  Token Value Capture
                </Typography>
              </Nav.Link>
              <Nav.Link
                style={{ fontSize: "1vw" }}
                id="item2"
                href="#tokenomics"
                className="nav-link"
              >
                <Typography
                  fontFamily={"ST MicroSquare Ex"}
                  style={{ fontWeight: 700 }}
                  sx={{
                    fontSize: fs,
                  }}
                >
                  Token Overview
                </Typography>
              </Nav.Link>
              <Nav.Link
                style={{ fontSize: "1vw" }}
                id="item3"
                href="#taxes"
                className="nav-link"
              >
                <Typography
                  fontFamily={"ST MicroSquare Ex"}
                  style={{ fontWeight: 700 }}
                  sx={{
                    fontSize: fs,
                  }}
                >
                  Taxes
                </Typography>
              </Nav.Link>
              <Nav.Link
                style={{ fontSize: "1vw" }}
                id="item4"
                href="#roadmap"
                className="nav-link"
              >
                <Typography
                  fontFamily={"ST MicroSquare Ex"}
                  style={{ fontWeight: 700 }}
                  sx={{
                    fontSize: fs,
                  }}
                >
                  Roadmap
                </Typography>
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
}

export default NavbarC;
